<template>
  <div class="w-full">
    <NotifyMeButton
      type="secondary"
      :text="$t('Check availability')"
      @click="toggleNotifyMeModal()"
    />
    <LazyNotifyMeModal
      v-if="showNotifyMeModal"
      :product-sku="productSku"
      @close="toggleNotifyMeModal()"
    />
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'NotifyMe',

  props: {
    productSku: {
      type: String,
      required: true,
    },
  },

  setup() {

    const showNotifyMeModal = ref(false);

    const toggleNotifyMeModal = () => {

      showNotifyMeModal.value = !showNotifyMeModal.value;
    
    };

    return {
      showNotifyMeModal,
      toggleNotifyMeModal,
    };
  
  },
});

</script>
